import {Component, OnInit} from '@angular/core';

import Map from 'ol/Map';
import View from 'ol/View';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
// import VectorTileLayer from 'ol/layer/VectorTile.js';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
// import {StyleLike} from "ol/style/Style";
import {fromLonLat as transformLonLat} from 'ol/proj.js';
import {MapService} from "../../services/map.service";
import {centers, extents, layerStyle} from "../../var/constants";
import {HttpClient} from "@angular/common/http";
// import {firstValueFrom} from "rxjs";
// import {applyStyle} from "ol-mapbox-style";
import GeoJSON from "ol/format/GeoJSON.js";
import {nrwMask, tileWMS} from "../../var/layers";

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  map: Map | undefined;

  constructor(
      private http: HttpClient,
      private mapService: MapService
  ) {
  }

  /**
   * A lifecycle hook that is called after Angular has initialized all data-bound properties of a directive.
   * The map and the vectorlayers are created.
   * @returns void
   */
  async ngOnInit() {
    // vectorlayer for displaying geometry like districts or states
    const regionsLayer = new VectorLayer({
      source: new VectorSource({}),
      style: layerStyle
    });
    regionsLayer.set('name', 'regionsLayer');
    // vectorlayer for displaying drawn geometries
    const drawLayer = new VectorLayer({
      source: new VectorSource({}),
      style: layerStyle
    });
    drawLayer.set('name', 'drawLayer');
    drawLayer.on('change', () => this.mapService.checkMinimumAreaSize());

    // const style = await firstValueFrom(this.http.get('https://sgx.geodatenzentrum.de/gdz_basemapde_vektor/styles/bm_web_col.json')) as StyleLike;
    // const vectorTiles = new VectorTileLayer({});
    // await applyStyle(vectorTiles, style);

    // NRW-Atlas: Topographic map (all zoom lvl)
    this.map = new Map({
      target: 'map',
      pixelRatio: 1,
      layers: [
        // vectorTiles,
        tileWMS,
        // nrwMask,
        regionsLayer,
        drawLayer
      ],
      view: new View({
        center: transformLonLat(centers.brd),
        zoom: 6,
        extent: extents.brd
      })
    });
    this.mapService.setMap(this.map);
  }

  /**
   * the mouseleave event is fired when the cursor leaves the map-div element
   * in this case the openlayers draw interaction will be removed and the user has to reactivate the draw
   * interaction by clicking on the button 'draw rectangle' or 'draw polygon'
   * @returns void
   */
  mouseLeaveEvent(): void {
    this.mapService.removeInteraction();
  }
}
